import { module } from 'modujs';
import { html } from '../utils/environment'
import * as focusTrap from 'focus-trap';
import gsap from 'gsap'
import { shuffle, moveOneLetter, marquee } from '../utils/string'

export default class extends module {
    constructor(m) {
        super(m);

        this.$header = this.$('header')[0]
        // this.$logo = this.$('logo')[0]
        this.$menuToggler = this.$('menu-toggler')[0]
        this.$menu = this.$('menu')[0]

        this.events = {
            click: {
                'menu-toggler': 'toggleMenu',
                'logo': 'hideMenu'
            }
        }
    }

    init() {
        window.addEventListener('keydown', this.onKeyDown = e => {
            // Escape key
            if(e.keyCode === 27 && this.hasMenuOpened()) {
                this.hideMenu()
            }
        })

        this.focusTrap = focusTrap.createFocusTrap([this.$header, this.$menu]);
    }

    hasMenuOpened() {
        return html.classList.contains('has-menu-opened')
    }

    showMenu() {
        html.classList.add('has-menu-opened')
        this.$menuToggler.innerText = this.getData('close-label', this.$menuToggler)
        this.$menuToggler.setAttribute('aria-expanded', true);

        this.focusTrap.activate()
    }

    hideMenu() {
        html.classList.remove('has-menu-opened')
        this.$menuToggler.innerText = this.getData('open-label', this.$menuToggler)
        this.$menuToggler.setAttribute('aria-expanded', false);

        this.focusTrap.deactivate()
    }

    toggleMenu() {
        if(!this.hasMenuOpened()) {
            this.showMenu()
        } else {
            this.hideMenu();
        }
    }

    destroy() {
        super.destroy()

        this.focusTrap.deactivate()
    }
}
